(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/board-description.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/board-description.js');

'use strict';

const rulesRadio = svs.numbergames.game_model.rulesRadio;
svs.numbergames.game.views.BoardDescription = Marionette.View.extend({
  modelEvents: {
    'change:board change:level': 'render'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }],
  radioEvents: {
    'huxflux:end': 'render'
  },
  template: false,
  templateContext() {
    return {
      rules: rulesRadio.request('rules')
    };
  }
});

 })(window);